import { useConfigurationQuery } from './query/useConfigurationQuery';

export const useConfiguration = () => {
  const { data } = useConfigurationQuery();

  if (!data) {
    throw new Error(
      'Configuration is not loaded, did you forget to use <ConfigurationProvider>...</ConfigurationProvider>?'
    );
  }

  return data;
};
